import {
  APIContextOptions,
  APITypesV2,
  createAPIContext,
  createBloodSampleAPI,
  createBookingAPIv2,
  createConsentAPIv1,
  createConsentAPIv2,
  createEcgAPI,
  createNekoScopeAPI,
  createPatientAPI,
  createQuestionnaireAPI,
  createScanAPI,
  createScheduleAPI,
  createSiteAPI,
  createSiteCheckinSessionAPI,
  createUserAPI,
  createVisitAPI,
} from "@cur8/api-client";

export function createClient(options: APIContextOptions) {
  const context = createAPIContext(options);

  const baseSiteAPI = createSiteAPI(context);

  return {
    ecg: createEcgAPI(context),
    bloodSample: createBloodSampleAPI(context),
    booking: createBookingAPIv2(context),
    consent: createConsentAPIv1(context),
    consentV2: createConsentAPIv2(context),
    patient: createPatientAPI(context),
    scan: createScanAPI(context),
    schedule: createScheduleAPI(context),
    site: {
      ...baseSiteAPI,
      // TEMPORARY: remove once NekoLens is released to the public.
      // Used by useShowNekoLens to read MOOD site visibility. querySites
      // filters out non-public sites for this caller, so we hit
      // GET /api/v2/site/{siteId} directly. Drop this method (and
      // useSiteQuery) when the visibility gate is no longer needed.
      getSite: (siteId: string) => {
        const url = context.buildURL(
          `api/v2/site/${encodeURIComponent(siteId)}`
        );
        const request = new Request(url.toString(), {
          method: "GET",
          headers: { Accept: "application/json" },
        });
        return context.fetchJSON<APITypesV2.Site>(request);
      },
    },
    siteCheckinSession: createSiteCheckinSessionAPI(context),
    user: createUserAPI(context),
    visit: createVisitAPI(context),
    questionnaire: createQuestionnaireAPI(context),
    nekoScope: createNekoScopeAPI(context),
  };
}

export type APIClient = ReturnType<typeof createClient>;
